import './App.css';
import { comparePoke, Poke, reglesPoke } from './Rules';
import React from 'react';

const randomEnumValue = (enumeration: any) => {
  const values = Object.keys(enumeration);
  const enumKey = values[Math.floor(Math.random() * values.length)];
  return enumeration[enumKey];
}
let scoreP = 0
let scoreC = 0;
const divScoreP = document.createElement("div");
const divScoreC = document.createElement("div");
const divRule =  document.createElement("div");

function game(playerChoice: Poke) {
  let computerChoice: Poke = randomEnumValue(Poke);
  const divGame = document.getElementById("game");
  if (divGame != null) {
    divGame.appendChild(divRule)
  }
  if (comparePoke(playerChoice, computerChoice) < 0) {
    scoreC++;
    divRule.innerHTML = "You loose because " +  reglesPoke(playerChoice,computerChoice)

  }
  else if (comparePoke(playerChoice, computerChoice) > 0) {
    scoreP++;
    divRule.innerHTML =  "You win because " +  reglesPoke(playerChoice,computerChoice)
  }
  else {
    scoreC++;
    scoreP++;
    divRule.innerHTML = reglesPoke(playerChoice,computerChoice);
  }
  const d1 = document.getElementById("scC")
  const d2 = document.getElementById("scP")
  if (d1!=null && d2!=null){
    d1.innerHTML = ""+scoreC;
    d2.innerHTML = ""+scoreP;
  }
}

export function App2() {
    return (
      <div className="App">
        <header className="App-header">
        <div> <h1>Welcome to Shifumi with Pokemons</h1></div>
          <div id='game'>
          <img src={require('../src/assets/img/Bulbasaur.jpg')} onClick={() => game(Poke.Bulbasaur)} alt='Bulbasaur' />
          <img src={require('../src/assets/img/Squirtle.jpg')} onClick={() => game(Poke.Squirtle)} alt='Squirtle ' />
          <img src={require('../src/assets/img/Charmander.jpg')} onClick={() => game(Poke.Charmander )} alt='Charmander ' />
        </div>
      </header>
    </div>
  );
}

export default App2;
